import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var scrollTo = {
    selector: '[data-scroll-to]',
    isMoving: false,

    scrollTo( id, offset ) {
        var self = this;

        if (typeof offset === 'undefined' || window.innerWidth < 768) {
            offset = 0;
        }

        $( 'html, body' ).animate( {
            scrollTop: $( '#' + id ).offset().top + offset
        }, 800, () => {
            this.isMoving = false;
        } );
    },

    init: function() {
        var self = this,
            $link = $( self.selector );

        $link.on( 'click', ( e ) => {
            if ( this.isMoving ) {
                return false;
            }

            console.log('click');

            this.isMoving = true;

            let $target = $( e.currentTarget );
            this.scrollTo( $target.data( 'scroll-to' ), $target.data( 'scroll-offset' ));

            var navigation = document.querySelector( '.navigation__container' );

            enableBodyScroll( navigation );
            $( document.body ).removeClass( 'navigation-opened' );
            $( '.fl-symbol--hamburger' ).removeAttr( 'style' );
        } );
    }
};

export { scrollTo };
